import React from "react";
import { Grid, GridColumn, Modal, Typography } from "@sumprio/ui";
import ModalPortalRoot from "components/common/modals/ModalPortalRoot";
import type { PendingTermsInfo } from "store/api/termsApi";
import "./LayoutTermsModal.scss";

export interface LayoutTermsModalProps {
  open: boolean;
  terms: PendingTermsInfo | null;
  isSubmitting?: boolean;
  actionError?: string | null;
  onAccept: () => void;
  onReject: () => void;
}

export default function LayoutTermsModal({
  open,
  terms,
  isSubmitting = false,
  actionError = null,
  onAccept,
  onReject,
}: LayoutTermsModalProps) {
  if (!terms) return null;

  return (
    <ModalPortalRoot open={open} variant="center" className="layout-terms-modal-portal">
      <Modal
        variant="center"
        open={open}
        onClose={() => {}}
        closeOnBackdropClick={false}
        closeOnEscape={false}
        className="layout-terms-modal"
        title="Terms and Conditions"
        showCloseButton={false}
        showHeaderDivider
        showFooterDivider
        showCancelButton={false}
        showSecondaryButton
        secondaryLabel="Reject"
        onSecondary={onReject}
        secondaryDisabled={isSubmitting}
        showPrimaryButton="primary"
        primaryLabel={isSubmitting ? "Accepting…" : "Accept"}
        onPrimary={onAccept}
        primaryDisabled={isSubmitting}
        secondaryButtonProps={{ variant: "brand-secondaryGrey", size: "sm" }}
        primaryButtonProps={{ size: "sm" }}
        width={720}
      >
        <Grid display="flex" flexDirection="column" gap="md" width="100%">
          <GridColumn span={12}>
            <Typography
              variant="body"
              bodySize="sm"
              bodyWeight="regular"
              className="layout-terms-modal__text"
            >
              {terms.text}
            </Typography>
            {actionError ? (
              <Typography
                variant="body"
                bodySize="sm"
                bodyWeight="regular"
                color="danger"
                marginTop="md"
              >
                {actionError}
              </Typography>
            ) : null}
          </GridColumn>
        </Grid>
      </Modal>
    </ModalPortalRoot>
  );
}
